import * as React from 'react';
import axios from 'axios';

export const BrazilCheckout: React.FC<any> = ({ resources, customSetAddress, setIsDisabled, currentAddress }) => {
    const [zipcode, setZipcode] = React.useState<string>('');
    const [name, setName] = React.useState<string>('');
    const [street, setStreet] = React.useState<string>('');
    const [streetTwo, setStreetTwo] = React.useState<string>('');
    const [neighborhood, setNeighborhood] = React.useState<string>('');
    const [city, setCity] = React.useState<string>('');
    const [houseNum, setHouseNum] = React.useState<string>('');
    const [state, setState] = React.useState<string>('');
    const [address, setAddress] = React.useState<any>([]);
    const [disabled, setDisabled] = React.useState<any>(false);
    const findAddress = async () => {
        await axios({
            method: 'get',
            // url: `https://viacep.com.br/ws/01137-010/json`
            url: `https://viacep.com.br/ws/${zipcode}/json`
        }).then(response => {
            const address = {
                Name: name,
                Street: response.data.logradouro,
                City: response.data.localidade,
                DistrictName: response.data.bairro,
                State: response.data.uf,
                StreetNumber: houseNum,
                ZipCode: zipcode
            };
            if (response.data.logradouro) {
                customSetAddress(address);
                setAddress(address);
                setStreet(response.data.logradouro || '');
                setDisabled(true);
            }
        });
    };

    React.useEffect(() => {
        if (zipcode.length >= 8) {
            void findAddress();
        } else if (zipcode.length === 0) {
            setAddress(null);
            setDisabled(false);
            setStreet('');
        }
    }, [zipcode]);

    React.useEffect(() => {
        if (
            address &&
            address.City &&
            address.Name &&
            address.State &&
            address.ZipCode &&
            address.Street &&
            address.DistrictName &&
            address.StreetNumber
        ) {
            setIsDisabled(false);
        } else {
            setIsDisabled(true);
        }
    }, [address]);
    React.useEffect(() => {
        const address: any = {
            // Name: name,
            // Street: response.data.logradouro,
            // City: response.data.localidade,
            // DistrictName: response.data.bairro,
            // State: response.data.uf,
            // StreetNumber: houseNum,
            // ZipCode: zipcode
        };
        if (currentAddress && currentAddress.Name && currentAddress.Name !== '') {
            setName(currentAddress.Name);
            address.Name = currentAddress.Name;
        }
        if (currentAddress && currentAddress.City && currentAddress.City !== '') {
            setCity(currentAddress.City);
            address.City = currentAddress.City;
        }
        if (currentAddress && currentAddress.State && currentAddress.State !== '') {
            setState(currentAddress.State);
            address.State = currentAddress.State;
        }
        if (currentAddress && currentAddress.ZipCode && currentAddress.ZipCode !== '') {
            setZipcode(currentAddress.ZipCode);
            address.ZipCode = currentAddress.ZipCode;
        }
        if (currentAddress && currentAddress.Street && currentAddress.Street !== '') {
            const streetSplit = currentAddress.Street.split('\n');
            address.Street = currentAddress.Street;

            if (streetSplit && streetSplit[0]) {
                setStreet(streetSplit[0]);
            }
            if (streetSplit && streetSplit[1]) {
                setStreetTwo(streetSplit[1]);
            }
        }
        if (currentAddress && currentAddress.DistrictName && currentAddress.DistrictName !== '') {
            setNeighborhood(currentAddress.DistrictName);
            address.DistrictName = currentAddress.DistrictName;
        }
        if (currentAddress && currentAddress.StreetNumber && currentAddress.StreetNumber !== '') {
            setHouseNum(currentAddress.StreetNumber);
            address.StreetNumber = currentAddress.StreetNumber;
        }
        customSetAddress(address);
        // if (currentAddress && currentAddress.Name && currentAddress.Name !== '') {
        //     setName(currentAddress.Name);
        // }
    }, []);

    const nameChange = (value: string) => {
        const newAddress: any = {
            Name: value
        };
        setName(value);
        newAddress.Street = address && address.Street ? address.Street : streetTwo ? `${address.Street || street}\n${streetTwo}` : street;
        newAddress.City = address && address.City ? address.City : city;
        newAddress.DistrictName = address && address.DistrictName ? address.DistrictName : neighborhood;
        newAddress.ZipCode = address && address.ZipCode ? address.ZipCode : zipcode;
        newAddress.StreetNumber = address && address.StreetNumber ? address.StreetNumber : houseNum;
        newAddress.State = address && address.State ? address.State : state;

        customSetAddress(newAddress);
        setAddress(newAddress);
    };

    const houseNumChange = (value: string) => {
        const newAddress: any = {
            StreetNumber: value
        };
        setHouseNum(value);
        newAddress.Name = name;
        newAddress.Street = address && address.Street ? address.Street : streetTwo ? `${address.Street || street}\n${streetTwo}` : street;
        newAddress.City = address && address.City ? address.City : city;
        newAddress.DistrictName = address && address.DistrictName ? address.DistrictName : neighborhood;
        newAddress.ZipCode = address && address.ZipCode ? address.ZipCode : zipcode;
        newAddress.State = address && address.State ? address.State : state;

        customSetAddress(newAddress);
        setAddress(newAddress);
    };

    const cityChange = (value: string) => {
        const newAddress: any = {
            City: value
        };
        setCity(value);
        newAddress.Name = name;
        newAddress.Street = address && address.Street ? address.Street : streetTwo ? `${address.Street || street}\n${streetTwo}` : street;
        newAddress.DistrictName = address && address.DistrictName ? address.DistrictName : neighborhood;
        newAddress.ZipCode = address && address.ZipCode ? address.ZipCode : zipcode;
        newAddress.StreetNumber = address && address.StreetNumber ? address.StreetNumber : houseNum;
        newAddress.State = address && address.State ? address.State : state;

        customSetAddress(newAddress);
        setAddress(newAddress);
    };

    const neighborChange = (value: string) => {
        const newAddress: any = {
            District: value
        };
        setNeighborhood(value);
        newAddress.Name = name;
        newAddress.Street = address && address.Street ? address.Street : streetTwo ? `${address.Street || street}\n${streetTwo}` : street;
        newAddress.City = address && address.City ? address.City : city;
        newAddress.ZipCode = address && address.ZipCode ? address.ZipCode : zipcode;
        newAddress.StreetNumber = address && address.StreetNumber ? address.StreetNumber : houseNum;
        newAddress.State = address && address.State ? address.State : state;

        customSetAddress(newAddress);
        setAddress(newAddress);
    };

    const streetChange = (value: string) => {
        const newAddress: any = {
            Street: streetTwo ? `${value}\n${streetTwo}` : value
        };
        setStreet(value);
        newAddress.Name = name;
        newAddress.City = address && address.City ? address.City : city;
        newAddress.DistrictName = address && address.DistrictName ? address.DistrictName : neighborhood;
        newAddress.ZipCode = address && address.ZipCode ? address.ZipCode : zipcode;
        newAddress.StreetNumber = address && address.StreetNumber ? address.StreetNumber : houseNum;
        newAddress.State = address && address.State ? address.State : state;

        customSetAddress(newAddress);
        setAddress(newAddress);
    };

    const streetTwoChange = (value: string) => {
        const streetOne = address.Street ? address.Street.split('\n') : street ? street.split('\n') : '';
        const newAddress: any = {
            Street: `${streetOne && streetOne[0] ? streetOne[0] : ''}\n${value}`
        };
        setStreetTwo(value);
        newAddress.Name = name;
        newAddress.City = address && address.City ? address.City : city;
        newAddress.DistrictName = address && address.DistrictName ? address.DistrictName : neighborhood;
        newAddress.ZipCode = address && address.ZipCode ? address.ZipCode : zipcode;
        newAddress.StreetNumber = address && address.StreetNumber ? address.StreetNumber : houseNum;
        newAddress.State = address && address.State ? address.State : state;

        customSetAddress(newAddress);
        setAddress(newAddress);
    };

    const stateChange = (value: string) => {
        const newAddress: any = {
            State: value
        };
        setState(value);
        newAddress.Name = name;
        newAddress.City = address && address.City ? address.City : city;
        newAddress.Street = address && address.Street ? address.Street : streetTwo ? `${address.Street || street}\n${streetTwo}` : street;
        newAddress.DistrictName = address && address.DistrictName ? address.DistrictName : neighborhood;
        newAddress.ZipCode = address && address.ZipCode ? address.ZipCode : zipcode;
        newAddress.StreetNumber = address && address.StreetNumber ? address.StreetNumber : houseNum;

        customSetAddress(newAddress);
        setAddress(newAddress);
    };

    return (
        <div style={{ margin: '16px 18px' }}>
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressNameLabel}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={name}
                onChange={(e: any) => nameChange(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressZipCodeLabel}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={zipcode}
                maxLength={9}
                minLength={8}
                onChange={(e: any) => setZipcode(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {`${resources.addressHouseRULabel} *`}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={houseNum}
                onChange={(e: any) => houseNumChange(e.target.value)}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressStreetLabel1}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={street}
                onChange={(e: any) => streetChange(e.target.value)}
                disabled={disabled}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressMoreInformationLabel}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={streetTwo}
                onChange={(e: any) => streetTwoChange(e.target.value)}
                // disabled={address ? true : false}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {`${resources.addressDistrictLabel} *`}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={address ? address.DistrictName : neighborhood}
                onChange={(e: any) => neighborChange(e.target.value)}
                disabled={disabled}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {`${resources.addressStateLabel}`}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={address ? address.State : state}
                onChange={(e: any) => stateChange(e.target.value)}
                disabled={disabled}
            />
            <label
                style={{
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    lineHeight: '19px',
                    marginLeft: '8px'
                }}
            >
                {resources.addressCityLabel}
            </label>
            <input
                type='text'
                name=''
                id=''
                style={{
                    border: '1px solid #878A8C',
                    borderRadius: '2px',
                    boxSizing: 'border-box',
                    fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    lineHeight: '22px',
                    margin: '8px 0px',
                    padding: '8px',
                    width: '100%'
                }}
                value={address ? address.City : city}
                onChange={(e: any) => cityChange(e.target.value)}
                disabled={disabled}
            />
        </div>
    );
};
